import { createMock } from '../../utils/builderHelper.es.js';
import { ReleaseStateEnum } from '../../enums/ReleaseStateEnum.es.js';
import { ReleaseGlobalStateEnum } from '../../enums/ReleaseGlobalStateEnum.es.js';

const aReleaseListItem = createMock({
    id: 'release-id-1',
    name: 'Default release name',
    upcCode: '123456007413',
    state: ReleaseStateEnum.Draft,
    globalState: ReleaseGlobalStateEnum.Draft,
    creationTime: '2005-01-01T00:00:00.000Z',
    lastUpdateTime: '2017-06-02T14:21:20.958098+00:00',
    releaseTargetDate: '2017-06-01T00:00:00.000000+00:00',
    releaseDate: '2017-06-01T00:00:00.000000+00:00',
    hasCoverArt: true,
    hasCoverSong: true,
    countOfTracks: 5,
    isPublic: false,
});

export { aReleaseListItem };
